var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 72,
    viewBox: "0 0 106 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.1992 0H50.7951L29.0708 42.8958L29.0312 42.9747L31.5542 45.4942L35.6029 44.7645H35.6424L52.2122 28.2126L49.5015 25.5058L34.6895 40.2974L45.1468 19.6236L49.5213 23.9921L52.2319 21.2852L46.9687 16.0292L52.9972 4.1466L59.0109 16.0391L50.2767 24.7613L70.3273 44.7694L74.4154 45.5041L76.9384 42.9846L55.1992 0ZM71.2901 40.3073L55.7078 24.7514L60.8327 19.6335L71.2901 40.3073Z",
    fill: "#FAA61A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.139 52.6041V50.3213H15.0391V57.9143H22.139V55.6315H20.6133V56.3908H16.5696V51.8448H20.6133V52.6041H22.139Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2219 53.3535V57.9192H26.7012V51.8399H32.4038V55.1285L31.0115 55.9026L32.3149 57.9094H30.5029L28.8539 55.3603L30.8831 54.2361V53.3535H28.2219Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6694 51.8399V57.9192H36.9668V51.8399H42.6694ZM41.1487 56.3908V53.3535H38.4875V56.3908H41.1487Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9381 56.7063L51.7284 57.9094H47.2305V56.3908H51.1014L51.4174 56.0801V55.6315H47.2305V51.8399H52.9381V53.3535H48.7512V54.1129H52.9381V56.7063Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2037 56.7063L61.994 57.9094H57.4961V56.3908H61.3917L61.7077 56.0801V55.6315H57.5208V51.8399H63.2283V53.3535H59.0415V54.1129H63.2283L63.2037 56.7063Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5966 53.8565H69.2913V51.8448H74.6088V50.3213H67.7656V57.9143H69.2913V55.38H73.5966V53.8565Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.166 57.9192V51.8399H80.6867V57.9192H79.166Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8631 51.8399H90.9566V53.3535H88.8631V57.9192H87.3425V53.3634H85.2539V51.8497H88.8631V51.8399Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87242 71H11.0449L6.5963 61.1241H4.44855L0 71H5.61871V69.0179H3.07103L5.5249 63.5696L8.87242 71Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3956 69.4321L22.8256 71H16.9551V69.0278H21.9862L22.396 68.6185V68.0417H16.965V63.1111H24.371V65.0833H18.9399V66.0694H24.371L24.3956 69.4321Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7509 69.4321L36.1808 71H30.3301V69.0278H35.3613L35.771 68.6185V68.0417H30.34V63.1111H37.746V65.0833H32.3149V66.0694H37.746L37.7509 69.4321Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7044 71V66.4195L61.742 70.4428L58.7796 66.4195V71H56.8047V63.1111H58.7796L61.742 67.1246L64.7044 63.1111H66.6794V71H64.7044Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0341 64.4177V66.3899L79.5404 67.0506L80.0341 67.7113V69.6835L78.7109 71.0049H72.6133V63.116H78.7109L80.0341 64.4177ZM78.0592 65.7292V65.2362L77.8963 65.0784H74.5981V66.0645H77.8123L78.0592 65.7292ZM78.0592 68.8651V68.372L77.8123 68.0417H74.5981V69.0278H77.8963L78.0592 68.8651Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8908 67.7803V70.9951H85.9785V63.1062H87.9535V69.0228H90.9159V67.7803H92.8908Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8595 63.0963H43.6855V65.0735H50.8595V63.0963Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8595 69.0229H43.6855V71H50.8595V69.0229Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8671 66.1385H43.6855V67.9628H49.8671V66.1385Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M106 63.0963H98.8262V65.0735H106V63.0963Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M106 69.0229H98.8262V71H106V69.0229Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M105.008 66.1385H98.8262V67.9628H105.008V66.1385Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4928 51.9089H93.543V48.7287H97.4928V51.9089ZM93.9034 51.5391H97.1225V49.0985H93.9034V51.5391Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0108 49.5077C96.085 49.505 96.1591 49.5171 96.2286 49.5433C96.2982 49.5696 96.3617 49.6094 96.4156 49.6606C96.4626 49.7065 96.5 49.7613 96.5255 49.8219C96.551 49.8824 96.5642 49.9474 96.5642 50.0131C96.5642 50.0788 96.551 50.1438 96.5255 50.2043C96.5 50.2649 96.4626 50.3197 96.4156 50.3656C96.3199 50.4634 96.1918 50.523 96.0552 50.5333L96.5835 51.1299H96.0898L95.596 50.5382H94.8554V51.1299H94.416V49.5077H96.0108ZM94.8604 50.1832H95.9515C95.9969 50.1852 96.0413 50.1692 96.075 50.1388C96.1057 50.109 96.1234 50.0682 96.1243 50.0254C96.1245 50.0041 96.1202 49.983 96.1117 49.9635C96.1032 49.944 96.0906 49.9264 96.075 49.912C96.0413 49.8816 95.9969 49.8657 95.9515 49.8676H94.8406L94.8604 50.1832Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.6001584c9ee010acc8dca004de95cf99.svg";
export { ForwardRef as ReactComponent };